import { Navigate, Outlet } from "react-router-dom";
import withAppUserData, {
  UserData,
} from "../../../../shared/hocs/withAppUserData/withAppUserData";

import ROUTES from "../../Layout/components/Main/components/AppRouter/routes";

export type CompleteSignupGuardProps = {
  children?: JSX.Element;
};

function BaseCompleteSignupGuard({
  children,
  appUser,
}: CompleteSignupGuardProps & UserData) {
  if (appUser && !appUser.isComplete) {
    return <Navigate to={ROUTES.UPDATE_PROFILE} />;
  }

  return children ? children : <Outlet />;
}

const CompleteSignupGuard = withAppUserData<CompleteSignupGuardProps>(
  BaseCompleteSignupGuard
);

export default CompleteSignupGuard;
